// extracted by mini-css-extract-plugin
export var next = "Next-module--next--5287a";